import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

const host = import.meta.env.VITE_REVERB_HOST || window.location.hostname
const port = Number(
  import.meta.env.VITE_REVERB_PORT ||
    window.location.port ||
    (window.location.protocol === 'https:' ? 443 : 80)
)
const scheme = import.meta.env.VITE_REVERB_SCHEME || window.location.protocol.replace(':', '')
const forceTLS = scheme === 'https'

const getAuthHeaders = () => {
  const token = localStorage.getItem('token') || ''
  return token ? { Authorization: `Bearer ${token}` } : {}
}

const apiOrigin = (import.meta.env.VITE_API_URL || window.location.origin).replace(
  /\/api\/?$/,
  ''
)
const authEndpoint = `${apiOrigin}/api/broadcasting/auth`

const echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,

  wsHost: host,
  wsPort: port,
  wssPort: port,
  forceTLS,
  enabledTransports: ['ws', 'wss'],

  // El token se lee en cada autorización de canal, no al importar el módulo:
  // echo.js se carga ya en la pantalla de login, cuando aún no hay token.
  channelAuthorization: {
    endpoint: authEndpoint,
    transport: 'ajax',
    headersProvider: getAuthHeaders,
    params: {},
  },
})

export default echo
